// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"auto-logout_clearfix_3u_hc"};